import { render, staticRenderFns } from "./TreeGoods.vue?vue&type=template&id=7beacbbf"
import script from "./TreeGoods.vue?vue&type=script&lang=js"
export * from "./TreeGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports